import { DARK_NAV_COLOR, LIGHT_NAV_COLOR, NAV_COLOR_ATTRIBUTE_NAME } from './constants';

export const addNavColorAttribute = componentTheme => ({
  [NAV_COLOR_ATTRIBUTE_NAME]: componentTheme === 'dark' ? LIGHT_NAV_COLOR : DARK_NAV_COLOR,
});
